module.exports = __webpack_public_path__ + "img/img_display_8.f9e73e4c.svg";